import { useState, MouseEvent, useRef } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function SupportandHelp() {
  const [mobileMenuVisible, setMobileMenuVisible] = useState<boolean>(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const [productsMenuVisible, setProductsMenuVisible] =
    useState<boolean>(false);
  const handleSmoothScroll = (
    event: MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    event.preventDefault();
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuVisible(false);
    setIsDropdownVisible(false);
    setProductsMenuVisible(false);
  };
  return (
    <>
      <div
        className="surface py-3 px-5 shadow-2 flex align-items-center justify-content-between fixed top-0 w-full z-50"
        style={{
          zIndex: "999",
          backgroundColor: "#115c9f",
        }}
      >
        <Link to="/" state={{ scrollToId: 'home' }} id="home">
          <img
            src="/images/Navbar/fixLogo.png"
            alt="Image"
            style={{ height: "40px" }}
          />
        </Link>

        {/* Mobile menu button */}

        <div
          ref={mobileMenuRef}
          className={`align-items-center flex-grow-1 justify-content-between ${
            mobileMenuVisible ? "flex" : "hidden"
          } lg:flex absolute lg:static surface left-0 top-100 z-5 shadow-2 lg:shadow-none navs`}
          style={{ backgroundColor: "#115c9f" }}
        ></div>
      </div>

      <div
        className=""
        style={{
          color: "#115c9f",
          marginTop: "120px",
          fontFamily: "Poppins",
          fontWeight: "bold",
          fontSize: "20px",
          padding: "20px",
        }}
      >
        <h1 style={{ fontSize: "24px", fontWeight: "bold" }}>
          SmartSafetee FAQ
        </h1>
      </div>

      <div className="" style={{ padding: "20px" }}>
        {/* Card 1 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              1.{" "}
              <span style={{ marginLeft: "10px" }}>
                What are the uses if we use the Occupational Safety and Health
                Management System (SMK3) (SmartSafetee application) ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                This application is useful for controlling risks in the
                workplace to create a safe, efficient and sustainable work
                system.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 2 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              2.{" "}
              <span style={{ marginLeft: "10px" }}>
                What is the importance of the SmartSafetee Application in the
                world of work ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                In practice, every workplace has potential hazards that can
                cause work accidents or work-related diseases. According to the
                classical theory put forward by HW Heinrich in his book
                Industrial Accident Prevention: A Scientific Approach, 88% of
                work accidents are caused by unsafe acts , 10% by unsafe
                conditions , and 2% by uncontrollable factors. This fact shows
                that the majority of accidents can actually be prevented with a
                good supervision and education system. Therefore, companies need
                to have a system that allows them to measure, monitor, and
                evaluate K3 performance consistently.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 3 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              3.{" "}
              <span style={{ marginLeft: "10px" }}>
                What digital solutions are available in the SmartSafetee app ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                K3 documentation based on web and mobile applications to
                facilitate users in making reports. Another advantage is that
                companies can reduce paper use because the approval system is
                already provided in the SmartSafetee application.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 4 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              4.{" "}
              <span style={{ marginLeft: "10px" }}>
                What are the superior features of the SmartSafetee application ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                SmartSafetee is equipped with superior features, including :
              </p>
              <ul>
                <li>
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Asset Inspection and Work Process
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    A feature that allows companies to conduct regular
                    inspections of equipment and ensure operational safety and
                    suitability.
                  </span>
                </li>
                <li className="mt-3">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Inspection Scheduling
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    A feature that makes it easier for companies to schedule
                    routine inspections and get automatic reminders before the
                    inspection date. This is in accordance with the{" "}
                    <span style={{ marginLeft: "26px" }}>
                      preventive action principle recommended by OSHA (2023).{" "}
                    </span>
                  </span>
                </li>
                <li className="mt-3">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Work Permit Creation and Approval
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    This feature will digitize the work permit application
                    process, starting from application, approval to monitoring
                    the status of work implementation.
                  </span>
                </li>
                <li className="mt-3">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Hazard Identification and Control
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    This feature will refer to NIOSH's Hierarchy of Controls
                    approach . This feature will also help in assessing and
                    managing risks before hazards develop into workplace
                    accidents.
                  </span>
                </li>
                <li className="mt-3">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Document Expiration Reminder
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    This feature will automatically provide notifications or
                    alerts for important documents that are about to expire.
                    This supports regulatory compliance and minimizes{" "}
                    <span style={{ marginLeft: "26px" }}>
                      {" "}
                      administrative risks.
                    </span>
                  </span>
                </li>
                <li className="mt-3">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Recording and Reporting of Inspection Results
                  </strong>{" "}
                  <br />
                  <span style={{ marginLeft: "26px" }}>
                    All inspection results will be digitally documented,
                    facilitating historical data analysis and data-based
                    decision making.
                  </span>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        {/* Card 5 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              5.{" "}
              <span style={{ marginLeft: "10px" }}>
                What are the positive impacts of implementing the SmartSafetee
                application for Companies and Workers ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                <p className="mt-2">For Companies :</p>
                <ul>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Prevent losses due to work accidents and production
                    disruptions.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Increase productivity due to a safer and more comfortable
                    working environment.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Strengthening the Company's image as a workplace that cares
                    about the safety of its employees.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Improving compliance with national regulations related to
                    K3.
                  </li>
                </ul>
                <p className="mt-3">For Workers :</p>
                <ul>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Raise awareness of workplace hazards.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Understanding the rights and obligations related to work
                    safety.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Encourage safe work behavior, not only for yourself but also
                    for your coworkers.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Be prepared for emergency situations such as fire or
                    earthquake.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Simplifying K3 document administration.
                  </li>
                </ul>
              </p>
            </div>
          </ul>
        </div>

        {/* Card 6 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              6.{" "}
              <span style={{ marginLeft: "10px" }}>
                How to optimize the use of SmartSafetee App ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                Implementation of the SmartSafetee Application requires
                preparation, training and education for workers, as well as
                periodic monitoring and evaluation.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 7 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              7.{" "}
              <span style={{ marginLeft: "10px" }}>
                SmartSafetee application replaces existing K3 system ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                The SmartSafetee application complements and simplifies existing
                K3 systems.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 8 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              8.{" "}
              <span style={{ marginLeft: "10px" }}>
                Does the SmartSafetee App require any special training ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                SmartSafetee application provides application usage training, to
                make it easier for users to operate this application.
                SmartSafetee application also provides a user manual as a guide
                for users.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 9 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              9.{" "}
              <span style={{ marginLeft: "10px" }}>
                What are the featured features available in this application ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                <ul>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Document Manager.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Hazard Identification .
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Work Permit.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Process Inspection.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Asset Inspection.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Incident Report.
                  </li>
                </ul>
              </p>
            </div>
          </ul>
        </div>

        {/* Card 10 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              10.{" "}
              <span style={{ marginLeft: "10px" }}>
                Is this app free or paid ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                For this SmartSafetee application is free, and for the first
                time registering users will get limited features. And if you
                want to use a premium package, you can enter through the
                Subscription menu.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 11 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              11.{" "}
              <span style={{ marginLeft: "10px" }}>
                What payment methods are accepted ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                Currently we only accept Bank transfer and credit card methods.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 12 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              12.{" "}
              <span style={{ marginLeft: "10px" }}>
                Is the SmartSafetee app available in other languages ?{" "}
              </span>
            </li>
            <div style={{ padding: "20px" }}>
              <p className="ms-3">
                <strong>Answer :</strong>
                <br />
                Currently the SmartSafetee application is available in 2
                languages, namely Indonesian and English.
              </p>
            </div>
          </ul>
        </div>

        {/* Card 13 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              13.{" "}
              <span style={{ marginLeft: "10px" }}>
                What types of accounts are available ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              There are 3 types of accounts available, namely :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Administrator{" "}
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Supervisor{" "}
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Standard User{" "}
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 14 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              14.{" "}
              <span style={{ marginLeft: "10px" }}>
                What if we want to register an account on the SmarSafetee
                Application ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users can register an account through the application :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  by opening the SmartSafetee application by accessing
                  https://app.smartsafetee.com/. Will enter the application
                  Login page.
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Users can register a new account by clicking Sign Up For Free
                  on the Login page. And will enter the Sign Up For Free page.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  To complete the column, you can do the following :
                  <span>
                    <ul>
                      <li className="ms-3">
                        Name <span style={{ marginLeft: "68px" }}>:</span>{" "}
                        filled with full name{" "}
                      </li>
                      <li className="ms-3">
                        Job Title <span style={{ marginLeft: "51px" }}>:</span>{" "}
                        filled in with the registered position or division
                      </li>
                      <li className="ms-3">
                        Email <span style={{ marginLeft: "72px" }}>:</span>{" "}
                        filled with email address{" "}
                      </li>
                      <li className="ms-3">
                        Phone Number{" "}
                        <span style={{ marginLeft: "3px" }}>:</span> filled with
                        an active telephone number
                      </li>
                      <li className="ms-3">
                        Country <span style={{ marginLeft: "54px" }}>:</span>{" "}
                        filled with the name of the country
                      </li>
                      <li className="ms-3">
                        City <span style={{ marginLeft: "84px" }}>:</span>{" "}
                        filled with the name of the city{" "}
                      </li>
                      <li className="ms-3">
                        Postal Code{" "}
                        <span style={{ marginLeft: "28px" }}>:</span> filled
                        with postal code{" "}
                      </li>
                      <li className="ms-3">
                        Address <span style={{ marginLeft: "55px" }}>:</span>{" "}
                        filled with complete address{" "}
                      </li>
                    </ul>
                  </span>
                </li>
              </ul>
              Then click the Next button.
              <ul>
                <li className="ms-12 mt-2">
                  Company Name <span>:</span> filled with complete address{" "}
                </li>
                <li className="ms-12">
                  Company Type <span style={{ marginLeft: "10px" }}>:</span>{" "}
                  filled with the company type or type of company field.{" "}
                </li>
                <li className="ms-12">
                  Company Size <span style={{ marginLeft: "15px" }}>:</span>{" "}
                  filled in with the size or number of employees in the company.{" "}
                </li>
              </ul>
              <ul>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Check the box “I Agree the terms and conditions”
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Then click the Submit button
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  And a page appears with the words "Email Verification Sent!".
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  User receives a verification email. Open the email and verify
                  it.
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  After clicking the Verify button on the email, you will enter
                  the Create Password page.
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Completing the columns can be done as follows:
                </li>
              </ul>
              <span>
                <ul>
                  <li className="ms-12">
                    Email <span style={{ marginLeft: "89px" }}>:</span> fill in
                    with the registered email address{" "}
                  </li>
                  <li className="ms-12">
                    Password <span style={{ marginLeft: "61px" }}>:</span>{" "}
                    filled with a password of at least 8 characters{" "}
                  </li>
                  <li className="ms-12">
                    Confirm Password{" "}
                    <span style={{ marginLeft: "0px" }}>:</span> filled with a
                    password of at least 8 characters{" "}
                  </li>
                </ul>
              </span>
              <ul>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  After completing all the columns, click the Submit button. The
                  display will show that the account has been successfully
                  created. Then click the Go To Login Page{" "}
                  <span style={{ marginLeft: "26px" }}>
                    button. Successfully entered the Login page.{" "}
                  </span>
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 15 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              15.{" "}
              <span style={{ marginLeft: "10px" }}>
                How do I login if I forgot my password ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              If you forget your password, users can use the Forgot Password
              feature. In this application there is a forgot password feature.
              If the user forgets the account password, they can use this
              feature. This can be done by :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click Forgot Password on the Login page, and you will be taken
                  to the Reset Password page.
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  To complete the column, you can do the following: <br />{" "}
                  <span style={{ marginLeft: "28px" }}>
                    {" "}
                    Email : filled with the registered email address
                  </span>
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Then click the Submit button.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  The server will send to the email, after receiving the email
                  click the Reset button. Then the display will enter the Create
                  New Password page.
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Completing the columns can be done as follows : <br />{" "}
                  <span style={{ marginLeft: "119px" }}>
                    {" "}
                    Email : filled with the registered email address
                  </span>{" "}
                  <br />{" "}
                  <span style={{ marginLeft: "90px" }}>
                    Password : filled with new password{" "}
                  </span>
                  <br />
                  <span style={{ marginLeft: "28px" }}>
                    Confirm Password : fill in with the same new password{" "}
                  </span>
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Then click the Submit button, and a message will appear that
                  the new password has been successfully saved.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 16 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              16.{" "}
              <span style={{ marginLeft: "10px" }}>
                How do I change my profile information ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users can change profile information by :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click on the profile name, then a dropdown will appear
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click Profile, then you will enter the Profile page.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click the Edit button, then change the desired data.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  After that, click the Save button to save the changes.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 17 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              17.{" "}
              <span style={{ marginLeft: "10px" }}>
                How do I delete an account I created ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users cannot delete the main account, but users can delete the
              accounts they create. Users can also delete user data. To do this,
              do the following :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Select the data you want to delete, then click the Delete icon
                  button.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  A confirmation page pop-up will appear,
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Select Yes to continue deleting and select No to not delete.
                  Click the Yes button to continue deleting data.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 18 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              18.{" "}
              <span style={{ marginLeft: "10px" }}>
                How to create a new account in this application ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users can also add users by :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click the Add User button. Then you will enter the Add User
                  page,
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  To complete the column, you can do the following :
                </li>
                <ul>
                  <li>
                    Email <span style={{ marginLeft: "94px" }}>:</span> filled
                    with the user's active email address.{" "}
                  </li>
                  <li>
                    Full Name <span style={{ marginLeft: "61px" }}>:</span>{" "}
                    filled with the user's full name .
                  </li>
                  <li>
                    Phone Number<span style={{ marginLeft: "29px" }}>:</span>{" "}
                    filled with the user's telephone number.
                  </li>
                  <li>
                    Employee <span style={{ marginLeft: "63px" }}>:</span>{" "}
                    filled in with the user name that has been registered with
                    employee management.
                  </li>
                  <li>
                    Role <span style={{ marginLeft: "101px" }}>:</span> filled
                    with the registered user role.
                  </li>
                  <li>
                    New Password<span style={{ marginLeft: "33px" }}>:</span>{" "}
                    filled with the new user password.
                  </li>
                  <li>
                    Confirm Password<span style={{ marginLeft: "9px" }}>:</span>{" "}
                    filled with confirmation of the password that has been
                    entered.
                  </li>
                </ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  After all the columns have been filled in completely and make
                  sure there are no errors, then click the Save button to save.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 19 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              19.{" "}
              <span style={{ marginLeft: "10px" }}>
                How to upload documents in Document Manager ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users can upload new files, which can be done by :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click the Upload button. And the Add File page pop-up will
                  appear.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click the Select files button to select the desired files,
                  then complete the fields.
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  To complete it in the following way :
                </li>
                <ul>
                  <li>
                    Document Number <span style={{ marginLeft: "4px" }}>:</span>{" "}
                    filled with the document number .{" "}
                  </li>
                  <li>
                    Document Name <span style={{ marginLeft: "19px" }}>:</span>{" "}
                    filled with the document name.
                  </li>
                  <li>
                    Document Type <span style={{ marginLeft: "28px" }}>:</span>{" "}
                    filled with the document type.
                  </li>
                  <li>
                    Valid From <span style={{ marginLeft: "64px" }}>:</span>{" "}
                    filled in with the date when it starts to be
                    valid/applicable .
                  </li>
                  <li>
                    Valid To <span style={{ marginLeft: "85px" }}>:</span>{" "}
                    filled with the date when the validity ends/applicability
                    ends.
                  </li>
                </ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Once everything is complete, click the OK button to save.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 20 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              20.{" "}
              <span style={{ marginLeft: "10px" }}>
                How to add data to Hazard Identification ?{" "}
              </span>
            </li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3">
              <strong>Answer :</strong>
              <br />
              Users can add data by :
              <ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Click the Add Hazard Identification button. And will enter the
                  Add Hazard page,
                </li>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  To complete these columns, do the following :
                </li>
                <ul>
                  <li>
                    Date <span style={{ marginLeft: "4px" }}>:</span> filled
                    with the date when it occurred.{" "}
                  </li>
                  <li>
                    Document Number{" "}
                    <span style={{ marginLeft: "19px" }}>:</span> filled with
                    the document number.
                  </li>
                  <li>
                    Ref. Number<span style={{ marginLeft: "70px" }}>:</span>{" "}
                    filled with Ref. number.
                  </li>
                  <li>
                    PIC <span style={{ marginLeft: "131px" }}>:</span> filled in
                    with the name of the PIC/ employee who has been registered.
                  </li>
                  <li>
                    Supervisor <span style={{ marginLeft: "80px" }}>:</span>{" "}
                    filled in with the name of the employee who has been
                    registered to become a supervisor.
                  </li>
                  <li>
                    Department <span style={{ marginLeft: "69px" }}>:</span>{" "}
                    filled in with the name of the registered department.
                  </li>
                  <li>
                    Job Location <span style={{ marginLeft: "65px" }}>:</span>{" "}
                    filled in with the registered work location.
                  </li>
                  <li>
                    Job Description<span style={{ marginLeft: "49px" }}>:</span>{" "}
                    filled with job description.
                  </li>
                </ul>
                <li>
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  After completing it, click the Save button to save.
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* Card 21 */}
        <div className="card" style={{ marginTop: "30px", }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: "Poppins",
                fontWeight: "bold",
              }}
            >
              <span style={{ marginLeft: "10px",fontSize: "24px", fontWeight: "bold",color: "#115c9f", }}>Contact Us</span>
            </li>
            <li></li>
          </ul>
          <div style={{ padding: "20px" }}>
            <p className="ms-3" style={{ marginBottom: "6px" }}>
              For more questions and support, please contact us at :
            </p>
            <p className="ms-3" style={{ marginBottom: "6px" }}>
              SmartSafetee Support
            </p>
            <p className="ms-3" style={{ marginBottom: "6px" }}>
              Phone <span>:</span> +62 21 38815067
            </p>
            <p className="ms-3" style={{ marginBottom: "6px" }}>
              Email <span style={{ marginLeft: "7px" }}>:</span> cs@enerren.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
